import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  IconButton,
  Typography,
  useTheme,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "c:/Users/imana/Downloads/react-admin-dashboard-master/src/theme";
import Header from "c:/Users/imana/Downloads/react-admin-dashboard-master/src/components/Header";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../axiosInstance";
import { toast } from "react-toastify";

const SoftSkills = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deleteId, setDeleteId] = useState(null); // store the id to delete
  const token = localStorage.getItem("authToken");
  const navigate = useNavigate();

  // Fetch soft skills courses
  const fetchCourses = () => {
    setLoading(true);
    axiosInstance
      .get("/courses/soft-skills")
      .then((res) => setCourses(res.data))
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchCourses();
  }, [token]);

  // Handle delete
  const handleDelete = () => {
    if (!deleteId) return;
    setLoading(true);
    axiosInstance
      .delete(`/courses/${deleteId}`)
      .then(() => {
        toast.success("Course deleted successfully");
        setCourses((prev) => prev.filter((c) => c.id !== deleteId));
      })
      .catch(() => toast.error("Failed to delete course"))
      .finally(() => {
        setLoading(false);
        setDeleteId(null);
      });
  };

  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    { field: "title", headerName: "Course Title", flex: 1 },
    { field: "categoryName", headerName: "Category", flex: 1 },
    { field: "duration", headerName: "Duration (hrs)", width: 130 },
    {
      field: "imagePath",
      headerName: "Image",
      flex: 1,
      renderCell: ({ row }) => (
        <img
          src={row.imagePath}
          alt={row.title}
          style={{ width: 60, borderRadius: 4 }}
        />
      ),
    },
    {
      field: "purchased",
      headerName: "Purchased",
      width: 100,
      renderCell: ({ row }) => (
        <Typography
          color={
            row.purchased ? colors.greenAccent[500] : colors.redAccent[500]
          }
        >
          {row.purchased ? "Yes" : "No"}
        </Typography>
      ),
    },
    {
      field: "quizzes",
      headerName: "Quizzes",
      width: 150,
      renderCell: (params) => (
        <Button
          variant="contained"
          color="secondary"
          disabled={loading}
          onClick={() => navigate(`/courses/${params.row.id}/quizzes`)}
        >
          View Quizzes
        </Button>
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      renderCell: ({ row }) => (
        <>
          <IconButton
            color="secondary"
            disabled={loading}
            onClick={() => navigate(`/soft-skills/edit/${row.id}`)}
          >
            <EditIcon />
          </IconButton>
          <IconButton
            color="error"
            disabled={loading}
            onClick={() => setDeleteId(row.id)}
          >
            <DeleteIcon />
          </IconButton>
        </>
      ),
    },
  ];

  return (
    <Box m="20px">
      <Header
        title="PROFESSIONAL SKILLS"
        subtitle="List of all soft skill courses"
      />

      <Box display="flex" justifyContent="flex-end" mb={2}>
        <Button
          variant="contained"
          color="primary"
          disabled={loading}
          onClick={() => navigate("/soft-skills/add")}
        >
          Add New Course
        </Button>
      </Box>

      <Box
        m="0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": { border: "none" },
          "& .MuiDataGrid-cell": { borderBottom: "none" },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
        }}
      >
        <DataGrid
          rows={courses}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[10, 20, 50]}
          disableSelectionOnClick
        />
      </Box>

      {/* Delete Confirmation Dialog */}
      <Dialog open={Boolean(deleteId)} onClose={() => setDeleteId(null)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this course? This action cannot be
            undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            disabled={loading}
            onClick={() => setDeleteId(null)}
            color="secondary"
          >
            Cancel
          </Button>
          <Button disabled={loading} onClick={handleDelete} color="error">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default SoftSkills;
